
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const getPerformanceIcon = (performance: string) => {
  switch (performance) {
    case 'excellent': return <CheckCircle className="h-4 w-4 text-green-600" />;
    case 'good': return <CheckCircle className="h-4 w-4 text-blue-600" />;
    case 'fair': return <AlertTriangle className="h-4 w-4 text-yellow-600" />;
    case 'poor': return <XCircle className="h-4 w-4 text-red-600" />;
    default: return null;
  }
};

export const getPerformanceBadge = (performance: string) => {
  switch (performance) {
    case 'excellent': return <Badge className="bg-green-100 text-green-800">Excellent</Badge>;
    case 'good': return <Badge className="bg-blue-100 text-blue-800">Good</Badge>;
    case 'fair': return <Badge className="bg-yellow-100 text-yellow-800">Fair</Badge>;
    case 'poor': return <Badge variant="destructive">Poor</Badge>;
    default: return <Badge variant="secondary">Unknown</Badge>;
  }
};
